import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const NavDropdown = ({ title, icon, onClick, popup, children }) => {
	return (
		<div>
			<button
				onClick={onClick}
				className={`w-full px-4 py-2 flex justify-between items-center ${
					popup ? "bg-slate-700/50 text-white" : "text-slate-300 hover:bg-slate-700/30"
				} rounded-lg transition-all duration-300`}
			>
				<div className="flex items-center gap-3">
					<span className={popup ? "text-white" : "text-slate-400"}>{icon}</span>
					<span className="font-medium">{title}</span>
				</div>
				{popup ? (
					<ChevronDown className="text-white" size={16} />
				) : (
					<ChevronRight className="text-slate-400" size={16} />
				)}
			</button>
			{popup && (
				<div className="mt-1 ml-4 pl-4 border-l border-slate-600 space-y-1">
					{children}
				</div>
			)}
		</div>
	);
};


export default NavDropdown;
